import React from 'react'

import CircularProgress from '@mui/material/CircularProgress'
import Box from '@mui/material/Box'

const Loading = props => (
  <Box my={4} align='center' {...props}>
    <CircularProgress color='primary' />
  </Box>
)

export default Loading
